import { FC, FormEvent, ReactNode } from 'react';
import { Tag } from 'antd';
import classNames from 'classnames';

interface IOwnProps {
  children: ReactNode;
  color: 'green' | 'red' | 'orange' | 'gray' | 'blue';
  className?: string;
  onChange?: (event: FormEvent<HTMLSpanElement>) => void;
}

const TagComponent: FC<IOwnProps> = ({ children, color, className }) => {
  const tagClasses = classNames(className, `ant-tag--${color}`);
  return <Tag className={tagClasses}>{children}</Tag>;
};

export default TagComponent;
